import { Component, EventEmitter, OnInit, Input, Output, ViewChild, VERSION } from '@angular/core';
import { FormControl, FormGroup, UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { ADPResourceService, CustomFormControl } from 'digital-core';
import { CountryCode, isValidPhoneNumber } from 'libphonenumber-js';
import { combineLatest, concatMap, filter, Subscription, tap } from 'rxjs';
import { AccountService } from 'src/app/core/services/account.service';
import { DeviceInventoryService } from 'src/app/core/services/device-inventory.service';
import { DeviceDto } from 'src/app/core/services/device-inventory/device.dto';
import { InventoryInfoDto } from 'src/app/core/services/device-inventory/inventory-info.dto';
import { ISelectedContract, LoggedInUserSettings } from 'src/app/core/services/settings/logged-in-user-settings';
import { UtilityService } from 'src/app/core/services/utility.service';
import { PghUserDeviceBase } from 'src/app/shared/device/pgh-user-device';
import { SelectedDeviceService } from 'src/app/shared/device/selected-device.service';
import { NgxQrcodeElementTypes, NgxQrcodeErrorCorrectionLevels } from '@techiediaries/ngx-qrcode';
import { buildDeviceDisplayName } from 'src/app/shared/device/device-display-name.pipe';
import { ConfirmationDialogData } from 'src/app/shared/components/confirmation-dialog/confirmation-dialog-data';
import { ConfirmationDialogComponent } from 'src/app/shared/components/confirmation-dialog/confirmation-dialog.component';
import { MatDialog } from '@angular/material/dialog';
import { Location } from '@angular/common';
import { dashboardRouteWithSlash } from 'src/app/route-constants';

@Component({
  selector: 'pgh-additional-device-selection',
  templateUrl: './additional-device-selection.component.html',
  styleUrls: ['./additional-device-selection.component.scss']
})
export class AdditionalDeviceSelectionComponent implements OnInit {
  @Output() nextEvent = new EventEmitter();
  @Output() backEvent = new EventEmitter();
  @Input() public preSelectedDevice?: PghUserDeviceBase;

  programCode: string;
  hylaLink: string;

  public elementType:NgxQrcodeElementTypes;
  public value:string;
  public correctionLevel:NgxQrcodeErrorCorrectionLevels;

  public backLabel: string;

  public isOnboardingFlow: boolean = false;
  public isAdditionalDeviceQuestionnaireFlow: boolean = false;
  public isBackVisible: boolean = false;

  private subscriptions: Subscription[] = [];

  public additionalDeviceSelectionForm: UntypedFormGroup;

  constructor(
    public resourceService: ADPResourceService,
    private utilityServce: UtilityService,
    private accountService: AccountService,
    private loggedInUserSettings: LoggedInUserSettings,
    private dialog: MatDialog,
    private router: Router,
    public route: ActivatedRoute,
    private location: Location,
  ) { }


  ngOnInit(): void {

    this.route.queryParams.subscribe(params => {
      this.isOnboardingFlow = (params.isOnboardingFlow && params.isOnboardingFlow.toLowerCase().trim() === 'true');
    });

    this.route.queryParams.subscribe(params => {
      this.isAdditionalDeviceQuestionnaireFlow = (params.isAdditionalDeviceQuestionnaireFlow && params.isAdditionalDeviceQuestionnaireFlow.toLowerCase().trim() === 'true');
    });

    this.additionalDeviceSelectionForm = new FormGroup({
      selectedAnswer: new FormControl('', Validators.required)
    });
  }

  public handleNextEvent() {

    const selectedDeviceType = [this.additionalDeviceSelectionForm.get('selectedAnswer').value];

    if (this.additionalDeviceSelectionForm.valid)
     {
      if(selectedDeviceType[0]=== 'TABL'){
        this.router.navigate(['tablet-registration'],{ queryParams: { isOnboardingFlow: 'true', isAdditionalDeviceFlow: 'true'}});
      }
      else if(selectedDeviceType[0] === 'SMAR'){
        this.router.navigate(['smartwatch-registration'],{ queryParams: { isOnboardingFlow: 'true', isAdditionalDeviceFlow: 'true'}});
      }
      else if(selectedDeviceType[0] === 'SMPH'){
        this.router.navigate(['phone-registration'],{ queryParams: { isOnboardingFlow: 'true', isAdditionalDeviceFlow: 'true'}});
      }
    }
  }

  public handleBack() {
    if (this.isAdditionalDeviceQuestionnaireFlow) {
      this.router.navigate(['additional-device-questionnaire']);
    } else {
      this.router.navigate([this.resourceService.getPortalSetting("URL_MyDevices").Value]);
    }
  }

  public handleExitToDashboard(){

    let dialogData: ConfirmationDialogData;

    dialogData = {
        title: "RegisterCellularDevice_AdditionalDevice_Questionnaire_Modal_Title",
        message: "RegisterCellularDevice_AdditionalDevice_Questionnaire_Modal_Message",
        cancelButtonText: "Global_Button_SkipForNow",
        confirmButtonText: "Global_Button_ContinueTest",
        contextData: { titleLeftAligned: false }
      };

    const confirmationDialog = this.dialog.open<ConfirmationDialogComponent, ConfirmationDialogData, boolean>(ConfirmationDialogComponent, {
      data: dialogData
    });
    this.subscriptions.push(confirmationDialog.afterClosed().subscribe({
      next: (result) => {
        if (result.toString() === 'false') {
          this.router.navigate([dashboardRouteWithSlash]);
        }
      }
    }));
  }
}
